module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('Modal', {
    attrs: {
      "title": "约陪练课",
      "width": "600",
      "mask-closable": false
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "chineseLessonForm",
    staticClass: "form",
    attrs: {
      "model": _vm.companionPracticingParam,
      "rules": _vm.chineseLessonRule,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "学生信息"
    }
  }, [_c('label', [_vm._v(_vm._s(_vm.companionPracticingParam.uid) + "  - " + _vm._s(_vm.companionPracticingParam.mobile) + " - " + _vm._s(_vm.companionPracticingParam.nickname))])])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 12
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始Level",
      "prop": "levelId"
    }
  }, [_c('Select', {
    attrs: {
      "filterable": "",
      "transfer": ""
    },
    on: {
      "on-change": _vm.changeLevel
    },
    model: {
      value: (_vm.companionPracticingParam.levelId),
      callback: function($$v) {
        _vm.$set(_vm.companionPracticingParam, "levelId", _vm._n($$v))
      },
      expression: "companionPracticingParam.levelId"
    }
  }, _vm._l((_vm.bookMaterialLevelList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title) + "(版本" + _vm._s(item.materialVersion) + ")")])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 10
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "教室",
      "prop": "schoolId"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.companionPracticingParam.schoolId),
      callback: function($$v) {
        _vm.$set(_vm.companionPracticingParam, "schoolId", _vm._n($$v))
      },
      expression: "companionPracticingParam.schoolId"
    }
  }, _vm._l((_vm.$constant.schoolEnums), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始课程",
      "prop": "lessonId"
    }
  }, [_c('Select', {
    attrs: {
      "transfer": ""
    },
    model: {
      value: (_vm.companionPracticingParam.lessonId),
      callback: function($$v) {
        _vm.$set(_vm.companionPracticingParam, "lessonId", _vm._n($$v))
      },
      expression: "companionPracticingParam.lessonId"
    }
  }, _vm._l((_vm.bookMaterialLessonsList), function(item) {
    return _c('Option', {
      key: item.id,
      attrs: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.title))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "开始时间",
      "prop": "lsnBeginDayTime"
    }
  }, [_c('Row', {
    attrs: {
      "gutter": 6
    }
  }, [_c('Col', {
    attrs: {
      "span": "7"
    }
  }, [_c('Form-item', [_c('Date-picker', {
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "placeholder": "请选择日期",
      "clearable": false
    },
    on: {
      "on-change": _vm.lsnBeginTimeDateChange
    },
    model: {
      value: (_vm.companionPracticingParam.lsnBeginTimeDate),
      callback: function($$v) {
        _vm.$set(_vm.companionPracticingParam, "lsnBeginTimeDate", $$v)
      },
      expression: "companionPracticingParam.lsnBeginTimeDate"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5"
    }
  }, [_c('Form-item', [_c('Time-picker', {
    attrs: {
      "clearable": false,
      "value": _vm.timeStr,
      "format": "HH:mm",
      "steps": [1, 30],
      "placeholder": "时间"
    },
    on: {
      "on-change": _vm.onChangeTime
    },
    model: {
      value: (_vm.companionPracticingParam.beginTime),
      callback: function($$v) {
        _vm.$set(_vm.companionPracticingParam, "beginTime", $$v)
      },
      expression: "companionPracticingParam.beginTime"
    }
  })], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "4"
    }
  }, [_c('Form-item', [_c('Select', {
    attrs: {
      "transfer": ""
    },
    on: {
      "on-change": _vm.clearTchList
    },
    model: {
      value: (_vm.companionPracticingParam.timeLength),
      callback: function($$v) {
        _vm.$set(_vm.companionPracticingParam, "timeLength", _vm._n($$v))
      },
      expression: "companionPracticingParam.timeLength"
    }
  }, _vm._l((_vm.timeLengthList), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "5",
      "offset": "1"
    }
  }, [_c('Button', {
    attrs: {
      "type": "info",
      "loading": _vm.loadingSearch
    },
    on: {
      "click": _vm.searchTch
    }
  }, [_vm._v("搜索")])], 1)], 1)], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "category"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.companionPracticingParam.category),
      callback: function($$v) {
        _vm.$set(_vm.companionPracticingParam, "category", $$v)
      },
      expression: "companionPracticingParam.category"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1"
    }
  }, [_c('span', [_vm._v("全职老师")])]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2"
    }
  }, [_c('span', [_vm._v("兼职老师")])])], 1)], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "空课老师"
    }
  }, [_c('TeacherSelect', {
    attrs: {
      "category": [1, 2, 3],
      "label": _vm.tchName
    },
    on: {
      "on-change": _vm.onTchChange
    },
    model: {
      value: (_vm.tId),
      callback: function($$v) {
        _vm.tId = $$v
      },
      expression: "tId"
    }
  })], 1), _vm._v(" "), _c('Form-item', {
    attrs: {
      "prop": "tchId"
    }
  }, [_c('Row', [_c('Radio-group', {
    model: {
      value: (_vm.companionPracticingParam.tchId),
      callback: function($$v) {
        _vm.$set(_vm.companionPracticingParam, "tchId", _vm._n($$v))
      },
      expression: "companionPracticingParam.tchId"
    }
  }, [_c('Row', _vm._l((_vm.tchList), function(item) {
    return _c('Col', {
      staticStyle: {
        "width": "140px"
      },
      attrs: {
        "span": 10
      }
    }, [_c('Radio', {
      key: item.id,
      attrs: {
        "label": item.id
      }
    }, [_vm._v(_vm._s(item.id) + " - " + _vm._s(item.firstName) + " " + _vm._s(item.lastName))]), _vm._v(" "), _c('a', {
      on: {
        "click": function($event) {
          return _vm.showTchMessage(item.id)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "120px",
        "height": "120px"
      },
      attrs: {
        "src": _vm.tchAvatarSrc(item.avatar)
      }
    })])], 1)
  }), 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingConfirm
    },
    on: {
      "click": _vm.insertChineseLesson
    }
  }, [_vm._v("确定")])], 1)], 1), _vm._v(" "), _c('tch-info-modal', {
    staticClass: "tch-info-modal",
    attrs: {
      "canEdit": false,
      "value": _vm.showTchInfoModal,
      "tchId": _vm.tchId,
      "successCallback": _vm.updateTchInfoSuccess
    },
    on: {
      "on-close": function($event) {
        _vm.showTchInfoModal = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-36ec610d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserPLLessonModal.vue
// module id = 1736
// module chunks = 8